import { useEffect, useRef } from "react";

/**
 * Whether Shift is down right now, as a ref.
 *
 * `ClipboardEvent` carries no modifier state, so the Ctrl+Shift+V → *extra* slot rule cannot be read
 * off the paste itself; the last keyboard event has to decide. Capture phase, so a field that stops
 * propagation cannot hide the key from us.
 *
 * A hook rather than two copies, because both the reading log's slots and the added card's slots
 * answer the same question and a drift between them would be invisible until you pasted into the
 * wrong one.
 */
export function useShiftHeld(): React.RefObject<boolean> {
  const shiftHeld = useRef(false);

  useEffect(() => {
    const track = (event: KeyboardEvent) => {
      shiftHeld.current = event.shiftKey;
    };
    window.addEventListener("keydown", track, true);
    window.addEventListener("keyup", track, true);
    return () => {
      window.removeEventListener("keydown", track, true);
      window.removeEventListener("keyup", track, true);
    };
  }, []);

  return shiftHeld;
}
